import React from 'react';
import { Box, Toolbar, useTheme } from '@mui/material';
import { useWindowSize } from 'react-use';

import { UnauthHeaderLayout, UnauthSidebarMenuLayout } from '.';

interface UnauthLayoutProps {
  children?: React.ReactNode;
}

export const UnauthLayout = ({ children }: UnauthLayoutProps) => {
  const theme = useTheme();
  const { width } = useWindowSize();

  return (
    <>
      <UnauthHeaderLayout />

      <UnauthSidebarMenuLayout />

      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: '100vh' }}>
        <Toolbar>
          <Box width="100%" />
        </Toolbar>

        <Box flex="1">
          <Box
            sx={{
              position: 'fixed',
              left: 0,
              bottom: 0,
              width: '100%',
              height: `calc(100vh - ${(width < theme.breakpoints.values.sm ? 56 : 64) + 3}px)`,
              borderRight: `100vw solid ${theme.palette.primary.main}`,
              borderBottom: `calc(100vh - ${(width < theme.breakpoints.values.sm ? 56 : 64) + 3}px) solid ${
                theme.palette.primary.light
              }`,
            }}
          />

          <Box sx={{ position: 'relative' }}>{children}</Box>
        </Box>
      </Box>
    </>
  );
};
